import { render, staticRenderFns } from "./AddMainCategory.vue?vue&type=template&id=0b85e121&scoped=true"
import script from "./AddMainCategory.vue?vue&type=script&lang=js"
export * from "./AddMainCategory.vue?vue&type=script&lang=js"
import style0 from "./AddMainCategory.vue?vue&type=style&index=0&id=0b85e121&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b85e121",
  null
  
)

export default component.exports